export default __webpack_public_path__ + "static/media/tokiTemperature@2x.2818e454.png";